module.exports = __webpack_public_path__ + "static/media/starEmpty.d88db0fb.png";